import { isString, assert, isFunction, isBoolean, hasOwnProperty } from './utils'

const DOMAIN_ID_TYPES = ['PERSONAL', 'TENANT', 'INNER', 'CUSTOMER', 'OA_CUSTOMER', 'TRACE_SOURCE' ]
const ENV_TYPES = ['prod', 'dev', 'qa', 'reg']
// const TRACK_TYPES = ['click', 'view']
const PROTOCOL_TYPES = ['http', 'https']

const configs = {
  domainId:{
    required:true,
    validate(value) {
      assert(isString(value), 'domainId must be string')
      assert(DOMAIN_ID_TYPES.includes(value), `The config domainId must one of ${DOMAIN_ID_TYPES.join('、')}, but got ${value}`)
    },
    default:'-1'
  },
  env:{
    required:true,
    validate(value) {
      assert(isString(value),'env must be string')
      assert(ENV_TYPES.includes(value),`The config env must one of ${ENV_TYPES.join('、')}, but got ${value}`)
    }
  },
  appName:{
    required:true,
    validate(value){
      assert(isString(value),'appName must be string')
    }
  },
  debug:{
    required:false,
    validate(value){
      assert(isBoolean(value),'debug must be Boolean')
    }
  },
  protocol:{
    required:false,
    validate(value){
      assert(isString(value),'protocol must be isString')
      assert(PROTOCOL_TYPES.includes(value),`The config env must one of ${PROTOCOL_TYPES.join('、')}, but got ${value}`)
    }
  },
}

const configsHandle = {
  trackName:{
    required:true,
    validate(value) {
      assert(isString(value),'trackName must be string')
    }
  },
  // trackType:{
  //   required:true,
  //   validate(value) {
  //     assert(isString(value), 'trackType must be string')
  //     assert(TRACK_TYPES.includes(value), `The config trackType must one of ${TRACK_TYPES.join('、')}, but got ${value}`)
  //   }
  // },
  fromPath:{
    required:false,
    validate(value) {
      assert(isString(value),'fromPath must be string')
    }
  },
}

function valdiateOption(config, options, key) {
  if (isFunction(config.required)) {
    config.required(options[key], options)
  } else if (config.required) {
    assert(hasOwnProperty(options, key), `${key} is required`)
  }

  if (config.validate && hasOwnProperty(options, key)) {
    config.validate(options[key], options)
  }
}

export function mergeDefaultConfig(options) {
  Object.keys(configs).forEach((key) => {
    const config = configs[key]
    valdiateOption(config, options, key)
    if (hasOwnProperty(config, 'default') && !hasOwnProperty(options, key)) {
      options[key] = config.default
    }
  })
  return options
}

export function mergeHandleConfig(options) {
  Object.keys(configsHandle).forEach((key) => {
    const config = configsHandle[key]
    valdiateOption(config, options, key)
    if (hasOwnProperty(config, 'default') && !hasOwnProperty(options, key)) {
      options[key] = config.default
    }
  })
  return options
}

